import React, { useState, useEffect, memo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { withStyles, useTheme } from '@material-ui/core/styles'
import { Badge } from '@material-ui/core'
import Snackbar from '../../atoms/feedback/snackbar'

import Avatar from '../../atoms/display/avatar'
import Typography from '../../atoms/display/typography'
import CircularProgress from '../../atoms/feedback/circularProgress'
import {
  ChevronLeftRounded as SmallIcon,
  ChevronRightRounded as LargeIcon,
} from '@material-ui/icons'

import useStyles from './userStyle'

import { setChangeStatus } from '../../../redux/changeStatus/actions'

const User = (props) => {
  const StyledBadge = withStyles((theme) => ({
    badge: {
      backgroundColor: theme.palette.status[props.status],
      color: theme.palette.status[props.status],
      width: 14,
      height: 14,
      borderRadius: '50%',
      top: 23,
      left: 23,
      border: `2px solid ${theme.palette.primary.secondary}`,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: '$ripple 1.2s infinite ease-in-out',
        border: '1px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  }))(Badge)

  const { t } = useTranslation()
  const classes = useStyles()
  const theme = useTheme()

  const { status: statusSignalR } = useSelector((state) => state.signalR)
  const version = useSelector((state) => state.version)
  const changeStatus = useSelector((state) => state.changeStatus)
  const [firstName, setFirstName] = useState()
  const [lastName, setLastName] = useState()
  const [status, setStatus] = useState()
  const [snackbar, setSnackbar] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    if (props.user?.name) {
      setFirstName(props.user?.name?.split(' ')[0])
      setLastName(props.user?.name?.split(' ')[1])
    }
  }, [props.user])

  const translateStatus = (name) => {
    switch (name) {
      case 'connected':
        return 0
      case 'disconnected':
        return 3
      case 'reconnecting':
        return 3
      default:
        return 4
    }
  }

  const renderLoading = () => {
    if (!props.loading) {
      return (
        <div
          style={{
            position: 'relative',
            top: 52,
            opacity: 1,
          }}
        >
          <CircularProgress
            variant={status?.variant}
            size={46}
            color="primary"
            status={status?.status}
          />
        </div>
      )
    }
  }

  useEffect(() => {
    const newStatus = translateStatus(statusSignalR)
    const variant =
      statusSignalR === 'connected' || statusSignalR === 'disconnected'
        ? 'determinate'
        : 'indeterminate'
    const obj = { status: newStatus, variant: variant }
    setStatus(obj)
  }, [statusSignalR])

  useEffect(() => {
    if (changeStatus) {
      setSnackbar(true)
      dispatch(setChangeStatus(false))
    }
  }, [changeStatus])

  return (
    <>
      {renderLoading()}
      <div className={classes.root}>
        <StyledBadge
          overlap="circle"
          variant="dot"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Avatar
            src={props.user?.url_avatar ?? ''}
            style={{ border: `2px solid ${theme.palette.primary.secondary}` }}
          >
            {firstName?.charAt(0).toUpperCase()}
            {lastName?.charAt(0).toUpperCase()}
          </Avatar>
        </StyledBadge>
      </div>
      {props.variant && (
        <Typography
          variant="body1"
          style={{ marginTop: 5, color: theme.palette.text.primary }}
        >
          {firstName && firstName} {lastName && lastName}
          {props.userMenuOpen ? (
            <SmallIcon
              style={{ float: 'right', fontSize: 20, marginLeft: 5 }}
            />
          ) : (
            <LargeIcon
              style={{ float: 'right', fontSize: 20, marginLeft: 5 }}
            />
          )}
        </Typography>
      )}
      {props.variant && (
        <Typography
          variant="body2"
          style={{ marginTop: 0, color: theme.palette.hover4 }}
        >
          {props.user?.nickname}
        </Typography>
      )}
      {/* Show app version */}
      <Typography
        variant="body2"
        style={{ marginTop: 0, color: theme.palette.hover4 }}
      >
        v{version}
      </Typography>

      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbar}
        onClose={() => {
          setSnackbar(false)
          dispatch(setChangeStatus(false))
        }}
        autoHideDuration={3000}
        message={t('alerts.changeStatusAlert')}
      />
    </>
  )
}

export default memo(User)
